module.exports = __webpack_public_path__ + "img/rujia_3.40db8e9c.png";